<template>
    <div>
        <a-card class="artiely-more-group-btn" :bodyStyle="{ padding: 0 }" :bordered="false">
            <a-tooltip placement="left">
                <template slot="title">配色设置</template>
                <div class="item" @click="toggle">
                    <a-icon type="heart" />
                </div>
            </a-tooltip>
            <!-- <a-tooltip placement="left">
                <template slot="title">文档说明</template>
                <div class="item">
                    <a-icon type="book" />
                </div>
            </a-tooltip>-->
        </a-card>

        <a-drawer title="配色设置" :width="300" @close="onClose" placement="right" :visible="visible">
            <div class="adrawer">
                <div class="media" v-for="(e,i) in themeList" :key="i">
                    <p>{{ e.text + ":" }}</p>
                    <div
                        @click="change(e.text,ce)"
                        class="tag"
                        v-for="(ce,ci) in e.tags"
                        :key="ci"
                        :style="{ backgroundColor: ce.color }"
                    >
                        <a-icon v-if="chooseTheme == ce.flag" type="check" />
                    </div>
                </div>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import {MEDIA,GOVERNMENT,CURRENCY} from '@/constants/theme-color'
export default {
    data() {
        return {
            visible: false,
            themeList: [
                {
                    text: "媒体",
                    tags: [{
                        id: 0,
                        flag:0,
                        color: '#2196F3'
                    }, {
                        id: 1,
                        flag:1,
                        color: '#026ABD'
                    }, {
                        id: 2,
                        flag:2,
                        color: '#464D75'
                    }]
                },{
                    text: "政务",
                    tags: [{
                        id: 0,
                        flag:3,
                        color: '#F44336'
                    }, {
                        id: 1,
                        flag:4,
                        color: '#F9605E'
                    }]
                },{
                    text: "通用",
                    tags: [{
                        id: 0,
                        flag:5,
                        color: '#EF6C00'
                    }]
                }
            ],
            chooseTheme: 1,

        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },
        onClose() {
            this.visible = false
        },
        change(title,e){
            this.chooseTheme = e.flag
            if(title == '媒体'){
                for (const key in MEDIA[e.id]) {
                    document.getElementsByTagName('body')[0].style.setProperty(`--${key}`, MEDIA[e.id][key]);
                }
            }else if(title == '政务'){
                for (const key in GOVERNMENT[e.id]) {
ame('body')[0].style.setProperty(`--${key}`, GOVERNMENT[e.id][key]);                    document.getElementsByTagN
                }
            }else if(title == '通用'){
                for (const key in CURRENCY[e.id]) {
                    document.getElementsByTagName('body')[0].style.setProperty(`--${key}`, CURRENCY[e.id][key]);
                }
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.artiely-more-group-btn {
    position: fixed;
    right: 0;
    top: 40%;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 0 $choose-color;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    z-index: 88;
    .item {
        width: 30px;
        height: 30px;
        margin: 5px;
        background: #fff;
        cursor: pointer;
        border-radius: 4px;
        @include flex(center);
        &:hover {
            background: #e9e9e9;
            .iconfont {
                color: #fff;
            }
        }
        .anticon {
            font-size: 20px;
        }
    }
}

.adrawer {
    .media {
        @include flex(flex-start);
        margin: 20px 0;
        p {
            font-size: 16px;
            font-weight: bold;
            margin-right: 12px;
        }
        .tag {
            cursor: pointer;
            width: 25px;
            height: 25px;
            border-radius: 5px;
            color: white;
            @include flex(center);
            margin: 0 12px;
        }
    }
}
</style>